<template>
  <div>
    <VHeader />
    <div id="form">
      <formList />
    </div>
    <!--    <van-button type="primary" @click="test()">主要按钮</van-button>-->
  </div>
</template>

<script>
import VHeader from './VHeader'
import formList from './formList'
// import { Dialog } from 'vant';

export default {
  name: 'home',
  data() {
    return {
    }
  },
  components: {
    VHeader,
    formList
    // [Dialog.Component.name]: Dialog.Component,
  },
  methods: {
    // test(){
    //   Dialog.alert({
    //     message: '弹窗',
    //   }).then(() => {
    //     // on close
    //   })
    // }
  },
}
</script>

<style scoped>
#form {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f8f9fa;
  min-height: calc(100vh - 60px);
}

@media screen and (max-width: 768px) {
  #form {
    padding: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue